import {EnrichedAstNode} from 'rendition-core/types';
import styled from 'styled-components';

interface Props {
    onClick?: () => void;
    color: string;
    workingNode: EnrichedAstNode;
}

export const WidthHeightLabels: React.FC<React.PropsWithChildren<Props>> = ({workingNode, color, onClick}) => {
    return (
        <>
            {workingNode.styles['width'] && (
                <WidthLabel onClick={onClick} color={color}>
                    {workingNode.styles['width']}
                </WidthLabel>
            )}
        </>
    );
};

const WidthLabel = styled.div<{color: string}>`
    top: -24px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${({color}) => color};
    padding: 2px;
    color: white;
    line-height: 20px;
    border-radius: 4px 4px 0 0;
    white-space: nowrap;
`;
